import React from 'react'
import moment from 'moment'
import {FemaleIcon, MaleIcon, EditIcon} from "../../../assets";
import {InfoText} from '../../../shared'
import styles from './styles.module.scss'
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import { toggleEditRequest } from '../../../app/app-slice';
import {GENDER, REQUEST_STATUSES} from "../../../services/constants";

const PatientInfo = () => {
  const {request} = useAppSelector(state => state.requests)
  const {requestReasons} = useAppSelector(state => state.app)
  const dispatch = useAppDispatch()
  const fullName = `${request.last_name} ${request.first_name || '-'} ${request.middle_name || '-'}`
  const sex = GENDER.find(data => data.key === request.sex)
  const requestReason = requestReasons.find(val => val.id === request.request_reason)
  return (
    <div id={styles.patientInfo}>
      <p className={styles.title}>{request.sex === 1 ? <MaleIcon/> : <FemaleIcon/>} Пациент</p>
      {/*{request.status !== REQUEST_STATUSES.closed && <EditIcon className={styles.editIcon} onClick={() => dispatch(toggleEditRequest())}/>}*/}
      <div className={styles.wrapper}>
        <InfoText title='ФИО пациента' text={request.name}/>
        <InfoText title='Номер полиса' text={request.policy_number || '-'}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText title='Дата рождения' text={`${moment(request.birthday).format('DD/MM/YYYY')}`}/>
        <InfoText title='Возраст / Пол' text={`${request.age} / ${sex?.type || '-'}`}/>
        {/*<InfoText title='Вес' text={`${request.data.weight ? request.data.weight + ' КГ' : '-'}`}/>
        <InfoText title='Лежачий ' text={`${request.data.in_bed || '-'}`}/>*/}
      </div>
      <div className={styles.wrapper}>
        <InfoText title='Телефон' text={request.contact_number || '-'}/>
        <InfoText title='Город' className={styles.city} text={request.city}/>
        <InfoText className={styles.addressInfo} title='Адрес' text={request.address}/>
        {/*<InfoText className={`mb-20 ${styles.subway}`} title='Метро' text={request.data.subway || '-'}/>*/}
      </div>
      {/*<div className={styles.wrapper}>
        <InfoText title='Дом' text={request.data.house || '-'}/>
        <InfoText title='Подъезд' text={request.data.entrance || '-'}/>
        <InfoText title='Код Подъезда' text={request.data.buzzer || '-'}/>
        <InfoText title='Квартира' text={request.data.apartment || '-'}/>
      </div>
      <div className={`${styles.wrapper} flex-start`}>
        <InfoText title='Лифт' text={request.data.elevator || '-'}/>
        <InfoText className='ml-40' title='Этаж' text={request.data.floor || '-'}/>
      </div>*/}
      <div className={styles.divider}/>
      {/*<InfoText className='mb-20 mt-20' title='Повод обращения' text={requestReason?.name || '-'}/>*/}
      <InfoText className='mb-20 mt-20' title='Примечания' text={request.notes || '-'}/>
      <InfoText className='mb-20' title='Жалобы / Дополнительная информация' text={request.complaints || '-'}/>
    </div>
  )
}

export default PatientInfo
